<div
  class="wrapper"
  [class.disabled-control]="isEdit && !isEditable"
>
  @if (isPossibleToEdit() && isInputFocused) {
    @if (useDynamicWidth && !dropdownSettingsStateService.isDropdownSettingsPageOpen()) {
      <input
        #inputField
        appDynamicWidth
        [currentTableZoom]="currentTableZoom"
        [parsedMinWidth]="getWidth()"
        type="text"
        inputmode="numeric"
        [(ngModel)]="value"
        [required]="required"
        (input)="handleInputEvent($event)"
        (blur)="handleValueChange(value); isInputFocused = false"
        (focus)="isInputFocused = true"
        (keydown)="preventInvalidNumericInput($event, true)"
        (dragstart)="preventDrag($event)"
      >
    } @else {
      <input
        type="text"
        inputmode="numeric"
        [(ngModel)]="value"
        [required]="required"
        (input)="handleInputEvent($event)"
        (blur)="handleValueChange(value);"
        (keyup.enter)="handleValueChange(value)"
        (dragstart)="preventDrag($event)"
      >
    }
  } @else {
    <div
      class="value-container"
      (click)="focusInput()"
      [style.min-width.px]="getWidth()"
    >
      {{ getPrefix() }}
      {{ formatNumberValue() }}
      {{ getPostfix() }}
    </div>
  }
</div>
